import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { actionMotionStyles } from "../micro-interactions/actionMotion";
import { ButtonStyle } from "./style";
import { black500 } from "../../../constants/color";
export const OutlineButon = ({ children, motion = false, disabled, onClick, mt = 0, mb = 0, type = "button", }) => {
    const theme = useTheme();
    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault();
            return;
        }
        if (onClick) {
            onClick();
        }
    };
    return (_jsx(Box, { component: "button", onClick: handleClick, disabled: disabled, width: "100%", mb: mb, type: type, sx: {
            ...ButtonStyle,
            ...(motion ? actionMotionStyles : {}),
            mt: `${mt}px`,
            background: 'white',
            border: `1px solid ${theme.palette.primary.main}`,
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.5 : 1,
        }, children: _jsx(Typography, { variant: "subtitle2", color: black500, children: children }) }));
};
